import type { FormatterArgs } from '@/services/types/formatter';
import { isArchivedNameCell, resolveRowMark } from '@/views/formatters/row-mark';

export default ({ data, key, colors }: FormatterArgs) => {
  const html = String(data[key] ?? '');

  if (isArchivedNameCell(data, key)) {
    return { kind: 'marked-html', html, archived: true };
  }

  const mark = resolveRowMark(data);
  if (mark && colors) {
    return { kind: 'marked-html', html, mark };
  }

  return { kind: 'html', html };
};
